import { LIST_GROUP_HEADER_CLASS } from 'utils/surfaceClasses';

// The head of a group of the table, across all its columns: « EN RETARD · 2 ».
// It stays under the table's head (`top`) while its rows scroll by, with its
// line under it; the next group's head then covers it.
const TaskGroupRow = ({ label, count, columns, top = 0 }) => (
  <tr>
    <td
      colSpan={columns}
      style={{ top }}
      className={`${LIST_GROUP_HEADER_CLASS} sticky z-10 border-b border-gray-100`}
    >
      {label} · {count}
    </td>
  </tr>
);

export default TaskGroupRow;
